import ArrowDown from '@assets/icons/arrow-down.svg'

interface ScrollToBottomButtonProps {
  onClick: () => void
}

export const ScrollToBottomButton = ({ onClick }: ScrollToBottomButtonProps) => {
  return (
    <div className="animate-fade-in absolute bottom-0 flex w-full justify-center bg-linear-to-t from-white to-transparent p-2">
      <button className="bg-primary rounded-full p-3" onClick={onClick}>
        <img src={ArrowDown} alt="Scroll to bottom" className="h-4 w-4" />
      </button>
    </div>
  )
}
